















































import BaseFormEdit from "../../models/base.form.edit";
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";
import { EventBus } from '@/event-bus';
import Swal from 'sweetalert2';

@Component({})
export default class Edit extends BaseFormEdit {
  services = [];
  form = { code: '', name: '', sections: [], sectionId: '' } as any;
  options = [];
  created() {
    this.parentValidator.extend("isCodeUnique", this.isCodeUnique);
    this.parentValidator.extend("positiveNumber", this.positiveNumber); 

    axios.get('/services?isActive=true').then((response) => {
      this.services = response.data.rows;
    });
  }

  get headers() : any {
    return [ { key: 'code', label: this.$t('Код услуги'), sortable: true },
             { key: 'name', label: this.$t('Название услуги'), sortable: true },
             { key: 'section', label: this.$t('Раздел услуги'), sortable: true },
             { key: 'active', label: this.$t('Действующая'), sortable: true },
             { key: 'createDate', label: this.$t('Дата создания'), sortable: true, formatter: (date : any) => moment(date).format('DD.MM.YYYY HH:mm') },
             { key: 'price', label: this.$t('Цена услуги, руб'), sortable: true },
             { key: 'currency', label: this.$t('Код валюты'), sortable: true },
             { key: 'id', label: '', sortable: false }
          ] 
  }

  @Watch('form.services')
  @Watch('form.sectionId')
  @Watch('services')
  onChildChanged(val: any, oldVal: any) {
    if(this.form.services && this.services) {
      let t = this.form.sections.filter((a: any) => a.key == this.form.sectionId);
      if(t.length)  {
        this.options = this.services.filter((item: any) => this.form.services.map((a : any) => a.id).indexOf(item.id) === -1 && t[0].value == item.section);
      }
    }
  }

  validateBeforeSubmit(isGoBack = false) {
    if(this.form.services.length > 0) {
      this.submit('/complexServices', isGoBack);
    } else {
      Swal(this.$t('Ошибка') + '', this.$t('Комплексная услуга должна содержать хотя бы одну услугу') + '', 'info');
    }
  }

  remove(id: any) {
    this.form.services = this.form.services.filter((item: any) => item.id != id);
  }

  get createDate() {
    return moment(String(this.form.createDate)).format("DD.MM.YYYY HH:mm");
  }

  addService(id: any) {
    if(id) {
      let service = this.services.filter((item: any) => item.id === id)[0];
      this.form.services.push(service);
      this.options = this.services.filter((item: any) => item.id !== id);
    }
  }

  isCodeUnique = {
    validate(value: any, args: any) {
      return axios
        .get("/Services/ValidateCode?code=" + value + "&id=" + args[0])
        .then(response => {
          return response.data;
        })
        .catch(() => {});
    }
  };

  positiveNumber = {
    validate(value: any, args: any) {
      return parseFloat(value) > 0;
    }
  };
}
